/**
 * About the App API endpoints
 */
import { api } from './baseApi';

export interface AboutTheApp {
  id: number;
  title: string;
  content: string;
  created_at: string;
  updated_at: string;
}

interface AboutResponse {
  success: boolean;
  data: AboutTheApp;
  message?: string;
}

export interface UpdateAboutData {
  title?: string;
  content?: string;
}

export const aboutApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAbout: builder.query<AboutResponse, void>({
      query: () => '/dashboard/about/',
      providesTags: ['About'],
    }),
    updateAbout: builder.mutation<AboutResponse, UpdateAboutData>({
      query: (data) => ({
        url: '/dashboard/about/',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['About'],
    }),
  }),
});

export const {
  useGetAboutQuery,
  useUpdateAboutMutation,
} = aboutApi;

